<template>
  <div>
    <div class="col-md-12">
      <div class="d-flex align-items-center position-relative my-1">
                    <span class="svg-icon svg-icon-1 position-absolute ms-6">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black"></path>
                      </svg>
                    </span>
        <input type="text"
               data-kt-user-table-filter="search"
               :value="modelValue"
               @input="updateValue"
               v-bind="$attrs"
               class="form-control form-control-solid ps-14"
               placeholder="Pesquisar o CID..."
               @keyup="getCids()">
      </div>
    </div>
    <div class="col-md-12 mb-6">
      <ul v-if="isOpenSearchCid" :id="'autocomplete_cids_'" class="scroll-y mh-200px mh-lg-350px">
        <li v-for="(cid, index) in cids" :key="index"  @click="setSearchCid(cid)" class="d-flex text-dark text-hover-primary align-items-center mb-5 cid-filter-item" >
          {{ cid.cid_code + ' - ' + cid.cid_name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import http from "../helpers/http";

export default {
  name: "InputSearchCid",
  inheritAttrs: false,
  emits: ["onSetSearchCid", "update:modelValue"],
  props: {
    modelValue: ''
  },
  data() {
    return {
      cids: [],
      isOpenSearchCid: false,
    }
  },
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value);
    },
    getCids() {
      http.get(`/cids`, {params:{ search: this.modelValue.toLowerCase()}}).then((response) => {
        this.cids = response.data;
        this.isOpenSearchCid = this.cids.length > 0;
      });
    },
    setSearchCid(cid) {
      this.$emit('update:modelValue', cid.cid_code + ' - ' + cid.cid_name);
      this.isOpenSearchCid = false;
      this.$emit('onSetSearchCid', cid);
    },
  }
}
</script>

<style scoped>

/* Estilo para os itens do filtro CID */
.cid-filter-item {
  cursor: pointer;
  font-size: 1.1rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.cid-filter-item:hover {
  background-color: #f8f9fa;
  border-color: #e9ecef;
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Melhora o input de busca */
.form-control {
  font-size: 1.1rem;
  padding: 0.75rem 1rem 0.75rem 3rem;
}

/* Estilo para a lista de resultados */
.scroll-y {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

</style>